// Silences expected browser-policy errors from play() while surfacing real failures.
// AbortError: load() called before play() resolved (track switch mid-flight).
// NotAllowedError: browser blocked autoplay — user hasn't interacted with page yet.
export function safePlay(audio: HTMLAudioElement, context?: string): void {
  audio.play().catch((err: unknown) => {
    if (
      err instanceof DOMException &&
      (err.name === 'AbortError' || err.name === 'NotAllowedError')
    )
      return
    console.error(`[Player] play() failed${context ? ` (${context})` : ''}:`, err)
  })
}
